import { useContext } from 'react';
import { GallectionType } from '../../types/gallection';
import { isSpecialStuckGallection } from '../../MediaPopup/helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isGroup } from '../../User/helpers';
import { normalizePremiumFolderData } from '../normalizePremiumFolderData';
import { useCurrentUser } from './useCurrentUser';
export default function useIsSellableAsPremiumGallery(currentFolder, hasSubfolders) {
    const isMobile = useContext(MobileContext);
    const currentUser = useCurrentUser();
    if (!currentFolder) {
        return false;
    }
    const isOwner = (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.owner.userId) === currentUser.userId;
    const isGallery = (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.type) === GallectionType.GALLERY;
    const { isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.premiumFolderData);
    return isOwner && isGallery && !isGroup(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.owner) && !(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.parentId) && // galleries with subfolders are not sellable
    !isMobile && // only desktop
    !isWatchToAccess && // watch-only galleries are not sellable
    !isPaidFolder && // already configured as premium
    !currentFolder.hasSubfolders && // galleries with subfolders are not sellable
    !hasSubfolders && // this checks for current state in case subgallery was just added
    !isSpecialStuckGallection(currentFolder) // special helper to find FEATURED | ALL
    ;
}

//# sourceMappingURL=useIsSellableAsPremiumGallery.js.map